module.exports = __webpack_public_path__ + "fonts/NunitoSans-Black.7cec6f9.woff2";